import React, { useEffect } from 'react'
import Breadcrumbs from 'components/Breadcrumbs'
import BlurLoading from 'components/Loading/BlurLoading'
import Navbar from 'components/Navbar'
import Sidebar from 'components/Sidebar'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'store'
import { LOADING } from 'store/modules/loading/types'
import { CorpoConteudo } from './style'
import * as loginActions from 'store/modules/login/actions'
import useRedux from 'hooks/useRedux'
import { LOGIN } from 'store/modules/login/types'
import { Box, styled, useTheme } from '@mui/material'
import { AUTH_SESSION_KEY } from 'models/enums'
import jwtDecode from 'jwt-decode'
import { NAVBAR } from 'store/modules/navbar/types'
import ModalAtendimentoAtivo from 'components/ModalAtendimentoAtivo'

type Props = {
  children?: JSX.Element | JSX.Element[]
}

function Main({ children }: Props) {
  const { isLoading } = useSelector<ApplicationState, LOADING>(
    (state) => state.loading
  )

  const { webSockets, atendimentoAtivoVerificado } = useSelector<
    ApplicationState,
    LOGIN
  >((state) => state.login)

  const { ramalAssociado } = useSelector<ApplicationState, NAVBAR>(
    (state) => state.navbar
  )

  const { dispatch } = useRedux()

  useEffect(() => {
    if (!webSockets.notificacaoInitialized) {
      dispatch(loginActions.setStatusWebSockets(true, 'notificacaoInitialized'))
      dispatch(loginActions.iniciarNotificacoes())
    }
    if (!webSockets.retornoDiscagemTelecomInitialized) {
      dispatch(
        loginActions.setStatusWebSockets(
          true,
          'retornoDiscagemTelecomInitialized'
        )
      )
      dispatch(loginActions.iniciarRetornoDiscagemTelecom())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])

  useEffect(() => {
    if (!atendimentoAtivoVerificado) {
      dispatch(loginActions.verificaAtendimentoAtivoSaga())
    }
  }, [dispatch, atendimentoAtivoVerificado])

  useEffect(() => {
    if (!webSockets.discadorInitialized && ramalAssociado.associado) {
      dispatch(loginActions.setStatusWebSockets(true, 'discadorInitialized'))
      dispatch(loginActions.iniciarDiscadorSaga())
    }
  }, [dispatch, ramalAssociado, webSockets.discadorInitialized])

  useEffect(() => {
    let timeout: NodeJS.Timeout | null = null

    const token = sessionStorage.getItem(AUTH_SESSION_KEY)
    if (token && ramalAssociado.associado) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const decodedToken: any = jwtDecode(token)
      const exp = decodedToken.exp * 1000
      const currentTime = Date.now()
      const timeToDesassociate = exp - currentTime - 5 * 60 * 1000

      if (timeToDesassociate > 0) {
        timeout = setTimeout(() => {
          dispatch(loginActions.desassociarRamalSaga())
        }, timeToDesassociate)
      } else {
        dispatch(loginActions.desassociarRamalSaga())
      }
    }

    return () => {
      if (timeout) clearTimeout(timeout)
    }
  }, [dispatch, ramalAssociado.associado])

  useEffect(() => {
    if (!ramalAssociado.associado) return

    const interval = setInterval(() => {
      dispatch(loginActions.pingRamalSaga())
    }, 30000)

    return () => {
      clearInterval(interval)
    }
  }, [dispatch, ramalAssociado.associado])

  const theme = useTheme()

  const NavbarMargin = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    minHeight: 'calc(64px + 50px)'
  }))

  return (
    <Box
      sx={{
        display: {
          md: '-webkit-box',
          xs: 'initial'
        }
      }}
    >
      <BlurLoading isLoading={isLoading} />
      <Navbar />
      <Breadcrumbs />
      <Sidebar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          marginLeft: {
            md: 'initial',
            xs: `calc(${theme.spacing(8)})`
          }
        }}
      >
        <NavbarMargin />
        <CorpoConteudo>{children}</CorpoConteudo>
        <ModalAtendimentoAtivo />
      </Box>
    </Box>
  )
}

export default Main
